import { MutationOptions } from 'react-query';
import { queryClient } from '../../../queryClient';
import {
  addOrgAccessToFarm,
  removeOrgAccessToFarm,
  updateOrgAccessToFarm,
} from './farm-orgs.api';
import {
  AddOrgAccessToFarmResponse,
  UpdateOrgAccessToFarmResponse,
} from './farm-orgs.schema';
import { FARM_ORGS_QUERY_KEY_PREFIX } from './farm-orgs.query';

export const getAddOrgAccessToFarmMutation = (
  solarFarmId: number,
  solarFarmOrgId: number,
): MutationOptions<
  AddOrgAccessToFarmResponse,
  Error,
  { orgIdToAdd: number; canEdit: boolean }
> => ({
  mutationFn: ({ orgIdToAdd, canEdit }) =>
    addOrgAccessToFarm(solarFarmId, solarFarmOrgId, orgIdToAdd, canEdit),
  onSuccess: () => {
    return queryClient.invalidateQueries({
      queryKey: [FARM_ORGS_QUERY_KEY_PREFIX],
      exact: false,
    });
  },
});

export const getUpdateOrgAccessToFarmMutation = (
  solarFarmId: number,
  solarFarmOrgId: number,
  orgId: number,
  permissionId: number,
): MutationOptions<
  UpdateOrgAccessToFarmResponse,
  Error,
  { canEdit: boolean }
> => ({
  mutationFn: ({ canEdit }) =>
    updateOrgAccessToFarm(
      solarFarmId,
      solarFarmOrgId,
      orgId,
      permissionId,
      canEdit,
    ),
  onSuccess: () => {
    return queryClient.invalidateQueries({
      queryKey: [FARM_ORGS_QUERY_KEY_PREFIX],
      exact: false,
    });
  },
});

export const getRemoveOrgAccessToFarmMutation = (
  solarFarmId: number,
  solarFarmOrgId: number,
  permissionId: number,
): MutationOptions<null, Error> => ({
  mutationFn: () =>
    removeOrgAccessToFarm(solarFarmId, solarFarmOrgId, permissionId),
  onSuccess: () => {
    return queryClient.invalidateQueries({
      queryKey: [FARM_ORGS_QUERY_KEY_PREFIX],
      exact: false,
    });
  },
});
